import { IAdminEvent, IAdminEventsStore } from '../store';

import api, { request } from '../../../../api';
import { IStore } from '../../../index';

export const all = async (_: IStore, clubId: number | string) => {
  const response = await request.get(api.admin.events(Number(clubId)));

  if (response.error) {
    return { errors: { events: { msg: 'Error retrieving the Admin Event List.' } } };
  }

  const allEvents = response.reduce(
    (parsedEvents: IAdminEventsStore, rawEvent: IAdminEvent) => ({
      ...parsedEvents,
      [rawEvent.id]: rawEvent
    }),
    {}
  );

  return {
    adminEvents: {
      all: allEvents
    }
  };
};
